<template>
  <v-card outlined class="pa-4 mb-4">
    <h3 class="subtitle-1 font-weight-medium">Conversion d’affichage</h3>
    <v-switch :input-value="settings.enabled" label="Convertir les mesures affichées" color="primary" dense @change="update('enabled', $event)" />
    <template v-if="settings.enabled">
      <v-alert dense text type="info">
        Sélectionnez uniquement les mesures à convertir. Les valeurs originales restent disponibles pour les calculs, conditions et actions.
        Dans les visuels, utilisez le champ avec le suffixe <code>_display</code> et <code>[[table||display_unit]]</code> pour l’unité.
        Les champs des requêtes doivent contenir des nombres ; les collections ne sont pas converties.
      </v-alert>
      <v-row dense>
        <v-col cols="12" md="6"><v-select :value="settings.family" :items="families" label="Famille de mesure" outlined dense @change="changeFamily" /></v-col>
        <v-col cols="12" md="6"><v-select :value="settings.storageUnit" :items="units" label="Unité des valeurs reçues" outlined dense @change="update('storageUnit', $event)" /></v-col>
        <v-col cols="12" md="6"><v-select :value="settings.displayUnit" :items="units" label="Unité affichée" outlined dense @change="update('displayUnit', $event)" /></v-col>
        <v-col cols="12" md="6"><v-text-field :value="settings.decimals" type="number" min="0" max="6" step="1" :rules="decimalRules" label="Nombre de décimales" outlined dense @input="changeDecimals" /></v-col>
        <v-col cols="12"><v-autocomplete :value="settings.fields" :items="fields" label="Champs de mesure à convertir" multiple chips deletable-chips clearable outlined dense @input="update('fields', $event || [])" /></v-col>
      </v-row>
      <v-alert v-if="collision" dense text type="warning">Une clé d’affichage existe déjà dans les données : elle est conservée et les champs correspondants ne sont pas proposés.</v-alert>
    </template>
  </v-card>
</template>

<script>
import { CONVERSION_FAMILIES, getConversionFamily, getConversionUnits, normalizeConversionSettings } from '@/services/fieldConversions'

export default {
  name: 'TimelineConversionSettings',
  props: {
    value: { type: Object, default: () => ({}) },
    fields: { type: Array, default: () => [] },
    collision: { type: Boolean, default: false },
  },
  computed: {
    settings() {
      const source = this.value || {}
      const normalized = normalizeConversionSettings({ ...source, defaultUnit: source.displayUnit })
      return { enabled: source.enabled === true, family: normalized.family, storageUnit: normalized.storageUnit,
        displayUnit: normalized.defaultUnit, decimals: normalized.decimals,
        fields: Array.isArray(source.fields) ? [...source.fields] : [] }
    },
    families() { return CONVERSION_FAMILIES.map(({ value, text }) => ({ value, text })) },
    units() { return getConversionUnits(this.settings.family).map(({ value, text }) => ({ value, text })) },
    decimalRules() {
      return [value => value !== null && value !== undefined && String(value).trim() !== ''
        && Number.isInteger(Number(value)) && Number(value) >= 0 && Number(value) <= 6 || 'Saisissez un nombre entier de 0 à 6.']
    },
  },
  methods: {
    // Le parent reçoit une nouvelle configuration, sans modifier les catalogues partagés.
    update(key, value) { this.$emit('input', { ...this.settings, [key]: value }) },
    changeFamily(value) {
      const family = getConversionFamily(value)
      this.$emit('input', { ...this.settings, family: family.value, storageUnit: family.baseUnit, displayUnit: family.defaultUnit })
    },
    changeDecimals(value) {
      if (value === null || String(value).trim() === '') return
      const decimals = Number(value)
      if (Number.isInteger(decimals) && decimals >= 0 && decimals <= 6) this.update('decimals', decimals)
    },
  },
}
</script>
